import * as React from 'react';

import {Card} from 'shells/card/card';
import {StarIcon} from 'shells/icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';

import {getImageFromCsmType} from './helpers';
import {useGetCsmInfo} from './use-get-csm-info';

import styles from './meet-your-csm.module.css';

export function MeetYourCsm() {
    const {csmInfo} = useGetCsmInfo();

    if (!csmInfo) {
        return null;
    }

    const {csmType, firstName, calendlyLink, emailAddress, funFact} = csmInfo;
    const source = getImageFromCsmType(csmType);

    return (
        <div className='pad-16'>
            <Card hasBorder={true}>
                <div className='pad-16'>
                    <StackLegacy spacing={12}>
                        <div className={styles.header}>
                            <img src={source} alt={firstName} className={styles.image} />
                            <div className={styles.intro}>
                                Meet {firstName}, your dedicated success strategist
                            </div>
                        </div>
                        <div>
                            {firstName} can help you set up your account, answer any questions, and
                            get Nutshell working for you in no time.
                        </div>
                        <StackLegacy spacing={6}>
                            <Link
                                variant='button-primary'
                                size='small'
                                isFullWidth={true}
                                href={calendlyLink}
                                newTab={true}
                            >
                                Schedule a call
                            </Link>
                            <Link
                                variant='button-secondary'
                                size='small'
                                isFullWidth={true}
                                href={`mailto:${emailAddress}`}
                                newTab={true}
                            >
                                Send an email
                            </Link>
                        </StackLegacy>
                        <div className={styles.fact}>
                            <div className={styles['fact-top']}>
                                <StarIcon size={12} className={styles.star} />
                                <div className={styles.fun}>Fun fact</div>
                            </div>
                            {funFact}
                        </div>
                    </StackLegacy>
                </div>
            </Card>
        </div>
    );
}
